import React from "react";

const GlobalLoader = () => {
    return <div class="loader"></div>;
};

export default GlobalLoader;
